import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React, { FC } from "react";
import { getCampaignUrgency } from "../campaign-urgency";
import type { CampaignSummary } from "@amzn/hardware-self-service-api-model";

interface CampaignStatusChipProps {
  campaign?: CampaignSummary;
}

const URGENCY_CHIP = {
  overdue: { label: getString("campaigns.urgency.overdue"), color: ChipBackgroundColor.Red },
  "escalating-soon": { label: getString("campaigns.urgency.escalatingSoon"), color: ChipBackgroundColor.Yellow },
  "due-soon": { label: getString("campaigns.urgency.dueSoon"), color: ChipBackgroundColor.Yellow },
} as const;

const ACTIVE_CHIP = { label: getString("campaigns.urgency.active"), color: ChipBackgroundColor.Green } as const;

export const CampaignStatusChip: FC<CampaignStatusChipProps> = ({ campaign }) => {
  if (!campaign) {
    return (
      <Chip size={ChipSize.ExtraSmall} backgroundColor={ChipBackgroundColor.Default}>
        {getString("campaigns.noCampaignChip")}
      </Chip>
    );
  }

  const urgency = getCampaignUrgency(campaign);
  const chip = urgency ? URGENCY_CHIP[urgency] : ACTIVE_CHIP;

  return (
    <Chip size={ChipSize.ExtraSmall} backgroundColor={chip.color}>
      {chip.label}
    </Chip>
  );
};
